/*
 * @Author: FRX
 * @Date: 2022-08-17 10:16:19
 * @LastEditors: FRX
 * @LastEditTime: 2022-08-19 14:10:30
 * @Description: 
 */
const h5Routes = [
    // 调试
    {
        path: "/mobile",
        name: "Moblile",
        component: () => import("../views/demo/mobile.vue"),
    },
    // h5体检报告列表
    {
        path: "/user/body-report/list",
        name: "UserBodyReportList",
        component: () => import("../views/mobile/bodyReport/reportList.vue"),
    },
    // h5体检报告详情
    {
        path: "/user/body-report/detail",
        name: "UserBodyReportDetail",
        component: () => import("../views/mobile/bodyReport/reportDetail.vue"),
    },
    // h5体检报告上传
    {
        path: "/user/body-report/import",
        name: "UserBodyReportImport",
        component: () => import("../views/mobile/bodyReport/reportImport.vue"),
    },
    // h5健康档案
    {
        path: "/user/health-archive",
        name: "HealthArchive",
        component: () => import("../views/mobile/health/healthArchiveCC.vue"),
    },
]
export default h5Routes;